import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RoomConnectPrep from '../ui/newfiles/RoomConnectPrep';
import { useDispatch } from 'react-redux';
import { updateAll, clearAll } from '../redux/streamInfoSlice';
import { updateCurrBoxNSeat } from '../redux/movingBoxSlice';
import { eventUpdate } from '../redux/eventStatusSlice';
import { getUserBrowserStorage, getSessionItem } from '../constants';

function TogetherPage() {
  const location = useLocation();
  const dispatch = useDispatch();

  const [boxRoomName, setBoxRoomName] = useState('');
  const [boxChatSid, setBoxChatSid] = useState('');
  const streamDetails = location.state.streamDetails;

  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const prevBoxSeatDetails = getSessionItem('prevBoxSeatDetails');
  const username = userDetails?.email;
  const firstName = userDetails?.firstName;
  const lastName = userDetails?.lastName;
  const userId = userDetails?.userId;
  const participantName = firstName + (lastName ? ' ' + lastName : '');

  const globalRoomName =
    JSON.stringify(streamDetails.eventId) + streamDetails.eventName;

  const updateStreamInfo = (
    boxRoomGen,
    defaultBoxName,
    boxEnter,
    defaultBox,
    globalChatSid,
    userEmail,
    participantName,
    userId
  ) => {
    dispatch(
      updateCurrBoxNSeat({
        boxID: boxEnter['boxId'],
        seatID: boxEnter['seatId'],
        boxSid: boxEnter['boxChatChannelSID'],
        boxName: boxEnter['boxName'],
      })
    );
    dispatch(
      updateAll({
        globalRoomName: globalRoomName,
        boxRoomName: boxRoomGen,
        defaultBoxName: defaultBoxName,
        eventID: streamDetails.eventId,
        createdBy: streamDetails.createdBy,
        defaultSeatBox: defaultBox,
        globalChatSid: globalChatSid,
        userEmail: userEmail,
        userId: userId,
        participantName: participantName,
        eventLayoutId: streamDetails.eventLayoutId_id,
        eventLayoutUrl: streamDetails.eventLayoutUrl,
      })
    );
    dispatch(
      eventUpdate({
        isInactive: false,
        userId: userId,
        eventId: streamDetails.eventId,
        eventUniqueNo: streamDetails.eventUniqueNo,
      })
    );
  };

  useEffect(() => {
    let boxEnter;
    const dummyBox = {
      boxChatChannelSID: '',
      boxId: '',
      boxName: '',
      defaultSeat: '',
      event_id: '',
      seatId: '',
      seatName: '',
    };

    const tempDefaultBox = streamDetails.assignSeats.find((box) => {
      if (box.defaultSeat === 1 && box.boxStatusPublic === 0) {
        return true;
      }
      return false;
    });

    const defaultBox = tempDefaultBox ? tempDefaultBox : dummyBox;

    if (prevBoxSeatDetails) {
      //will affect browser refresh
      const data = JSON.parse(prevBoxSeatDetails);
      boxEnter = { ...data };
    } else if (streamDetails.assignSeats.length < 2) {
      boxEnter = streamDetails.assignSeats[0];
    } else {
      boxEnter = streamDetails.assignSeats.find((box) => box.defaultSeat !== 1);
    }

    const boxRoomGen = globalRoomName + boxEnter['boxName'];
    setBoxChatSid(boxEnter['boxChatChannelSID']);
    boxEnter && setBoxRoomName(globalRoomName + boxEnter['boxName']);
    updateStreamInfo(
      boxRoomGen,
      defaultBox['boxName'],
      boxEnter,
      defaultBox,
      streamDetails.eventGlobalChannelSID,
      username,
      participantName,
      userId
    );
    return () => {
      dispatch(clearAll());
    };
  }, []);

  const renderFunc = () => {
    if (userId) {
      return boxRoomName.length && boxChatSid.length ? (
        <RoomConnectPrep
          boxRoomName={boxRoomName}
          username={username}
          globalRoomName={globalRoomName}
          url={streamDetails.eventStreamUrl}
          chatSID={streamDetails.eventGlobalChannelSID}
          eventLayoutURL={streamDetails.eventLayoutUrl}
          boxChatSid={boxChatSid}
          participantName={participantName}
          userId={userId}
          eventId={streamDetails.eventId}
        />
      ) : (
        <div>Gathering resources..</div>
      );
    } else {
      return <div>Sorry! you have to be logged in to watch the stream</div>;
    }
  };

  return renderFunc();
}

export default TogetherPage;
